import { motion } from "framer-motion";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-[#0A0A0A]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center lg:text-left">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-[#FF3B30] text-xs font-bold uppercase tracking-[0.3em]">About The League</span>
          <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
            Built For Players Who Never Stopped Loving The Game
          </h2>
          <div className="mt-8 space-y-5 text-[#C7CDD4] text-base sm:text-lg leading-relaxed font-medium">
            <p>
              The Weekend Adult Baseball League was created for players who still love baseball but can't commit to
              playing multiple nights a week.
            </p>
            <p>
              Whether you're a former high school player, a former college player, or just someone who misses competing on the
              diamond — this league is for you. Real competition that fits real life.
            </p>
            <p className="text-white font-bold">
              The response to our initial interest post has been incredible. We're building something for people who
              want a league that fits real life.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
